import { Injectable } from "@angular/core";
import { DynamicTableColumnModel } from "../../models/dto/core/dynamicTableColumn.model";

import html2pdf from 'html2pdf.js';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { PdfService } from "./pdf.service";
import { ExcelService } from "./excel.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from "rxjs/operators";
import { ExportExcelRequestModel } from "../../models/dto/core/export-excel-request.model";
import { PdfExportRequest } from "../../models/rest/core/pdf-export-request.model";
import { ExportBackendService } from "../export/export-backend.service";
import { ExportDataRequest } from "../../models/rest/export/export-data-request";
import { FileService } from "./file.service";
import { ExportFileResponse } from "../../models/rest/common/export-file-response";
import { ExportColumnInfo } from "../../models/rest/export/export-column-info";

@Injectable({
  providedIn: 'root'
})
export class ExportService {
  constructor(private sanitizer: DomSanitizer,
    private pdfService: PdfService,
    private fileService: FileService,
    private excelService: ExcelService,
    private exportBackendService: ExportBackendService,
    private http: HttpClient) { }

  // async exportPdfWithModel(request: PdfExportRequest) {

  //   let exportDataRequest = convertToExportDataRequestPdf(request);

  //   const res = await this.exportBackendService.exportToPdf(exportDataRequest).toPromise();

  //   await this.exportFileResponse(res);
  // }

  async exportFileResponse(request: ExportFileResponse) {

    const pdfBlob = this.fileService.base64ToBlob(request.data);

    this.fileService.downloadFile(pdfBlob, request.fileName || '');
  }


  // async exportPdfWithModelAngular(request: PdfExportRequest) {

  //   this.pdfService.exportPdfWithModel(request);

  // }

  // exportPdfForTableOld(title: string, data: any[], columns: DynamicTableColumnModel[], isLandscape: boolean = false) {

  //   let request = new PdfExportRequest();
  //   request.title = title;
  //   request.data = data;
  //   request.columns = columns;
  //   request.isLandscape = isLandscape;
  //   this.exportPdfWithModel(request);
  // }

  async exportExcel(request: ExportExcelRequestModel) {
    let exportDataRequest = convertToExportDataRequest(request);

    const res = await this.exportBackendService.exportToExcel(exportDataRequest).toPromise();

    const pdfBlob = this.fileService.base64ToBlob(res.data);
    this.fileService.downloadFile(pdfBlob, res.fileName);
  }


  exportExcelAngular(request: ExportExcelRequestModel) {
    this.excelService.exportExcelWithTable(request);
  }


  // exportExcelForTableOld(title: string, data: any[], columns: DynamicTableColumnModel[]) {
  //   let request = new ExportExcelRequestModel();
  //   request.fileName = title;
  //   request.data = data;
  //   request.columns = columns;
  //   request.addTotalRows = true;

  //   this.exportExcel(request);
  // }

  async exportFile(request: ExportDataRequest) {

    // if (request?.data?.length == 0)
    //   throw new Error("Liste boş olduğundan işleme devam edilemiyor.");

    const res = await this.exportBackendService.exportToFile(request).toPromise();

    const pdfBlob = this.fileService.base64ToBlob(res.data);
    this.fileService.downloadFile(pdfBlob, res.fileName);
  }

  getSafeHtmlContent(htmlContent: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  exportToTxt(content: string, fileName: string) {
    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    saveAs(blob, fileName + '.txt');
  }

  exportToCsv(content: string, fileName: string) {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, fileName + '.csv');
  }

  exportToPdf(content, fileName: string) {
    const blob = new Blob([content], { type: 'application/pdf' });
    saveAs(blob, fileName + '.pdf');
  }

  exportToHtml(content: string, fileName: string) {
    const blob = new Blob([content], { type: 'text/html;charset=utf-8' });
    saveAs(blob, fileName + '.html');
  }

  exportToJson(content: string, fileName: string) {
    const blob = new Blob([content], { type: 'text/html;charset=utf-8' });
    saveAs(blob, fileName + '.html');
  }

  exportToJsonFile(data: any, fileName: string) {
    const jsonString = JSON.stringify(data);
    const blob = new Blob([jsonString], { type: 'application/json' });

    saveAs(blob, fileName + '.json');
  }

  exportToXml(content: string, fileName: string) {
    const blob = new Blob([content], { type: 'text/xml;charset=utf-8' });
    saveAs(blob, fileName + '.xml');
  }

  saveHtmlAsPdf(htmlContent, fileName) {
    const safeHtmlContent: SafeHtml = this.getSafeHtmlContent(htmlContent);
    const element: HTMLElement = document.createElement('div');
    element.innerHTML = safeHtmlContent.toString();


    html2pdf()
      .from(element)
      .save(fileName);

  }
  downloadPdfAndSave(url, fileName) {
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (response: Blob) => {
        saveAs(response, fileName + '.pdf');
      },
      (error) => {

        throw new Error(error);

      }
    );
  }

  saveBlob(blob: Blob, fileName) {
    saveAs(blob, fileName);
  }
  getPdfFromUrl(url) {
    return this.http.get(url, { responseType: 'blob' });
  }


  downloadPdf2(url: string): Observable<Uint8Array> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/pdf' });
    return this.http.get(url, { headers, responseType: 'arraybuffer' }).pipe(
      map(response => new Uint8Array(response))
    );
  }
  convertToExportColumns(columns: DynamicTableColumnModel[]): ExportColumnInfo[] {
    return columns?.filter(x => (x.isExportExcel || x.isExportExcel == null)).map(column => ({
      header: column.header,
      field: column.field,
      dataType: column.dataType,
      align: column.align,
      dateFormat: column.dateFormat,
      translateKey: column.translateKey,
      totalsRowFunction: column.totalsRowFunction,
      isMerge: column.isMerge,

    }))

  }

}

// Convert ExportExcelRequestModel to ExportDataRequest
function convertToExportDataRequest(model: ExportExcelRequestModel): ExportDataRequest {
  return {
    fileName: model.fileName,
    data: model.data,
    customerId: model.customerId,
    isDateActive: model.isDateActive,
    startDate: model.startDate,
    endDate: model.endDate,
    currencyCode: model.currencyCode,
    columns: model.columns?.filter(x => (x.isExportExcel || x.isExportExcel == null)).map(column => ({
      header: column.header,
      field: column.field,
      dataType: column.dataType,
      align: column.align,
      dateFormat: column.dateFormat,
      translateKey: column.translateKey,
      totalsRowFunction: column.totalsRowFunction,
      isMerge: column.isMerge,
    }))
  };

}

function convertToExportDataRequestPdf(model: PdfExportRequest): ExportDataRequest {
  return {
    fileName: model.title,
    data: model.data,
    isLandscape: model.isLandscape,
    title: model.title,
    customerId: model.customerId,
    isDateActive: model.isDateActive,
    startDate: model.startDate,
    endDate: model.endDate,
    currencyCode: model.currencyCode,

    columns: model.columns?.filter(x => (x.isExportExcel || x.isExportExcel == null)).map(column => ({
      header: column.header,
      field: column.field,
      dataType: column.dataType,
      align: column.align,
      dateFormat: column.dateFormat,
      translateKey: column.translateKey,
      totalsRowFunction: column.totalsRowFunction,
      isMerge: column.isMerge,

    }))
  };


}
